import styled from 'styled-components';

export const ChartSpace = styled.div`
  width: 100%;
  height: 100%;
`;

export const HalfChart = styled.div`
  width: 50%;
  height: 100%;
`;
